import { styled } from 'stitches.config';
import { useIntl } from 'react-intl';
import Typography from '@/components/sushi/Typography';
import { toCurrency } from '@/utils/numberFormatter';

interface GraphTooltipProps {
  initialPatrimony: number;
  investment: number;
  netValue: number;
  year: number;
}
const currentYear = new Date().getFullYear();

export const GraphTooltip = ({
  initialPatrimony,
  investment,
  netValue,
  year,
}: GraphTooltipProps) => {
  const { formatMessage } = useIntl();

  return (
    <TooltipContainer>
      <Header>
        <Typography variant="bodyXS" color="secondary">
          {currentYear + year - 1}
        </Typography>
        <Typography variant="bodyXS" color="secondary">
          {toCurrency(netValue)}
        </Typography>
      </Header>
      <TooltipInfos>
        <InfoLine>
          <Typography variant="bodyXS">
            {formatMessage({
              id: 'wealth_simulator.chart.tootlip.interest',
            })}
          </Typography>
          <TooltipInterest variant="bodyXS">
            {toCurrency(netValue - investment)}
          </TooltipInterest>
        </InfoLine>
        <InfoLine>
          <Typography variant="bodyXS">
            {formatMessage({
              id: 'wealth_simulator.chart.tootlip.investment',
            })}
          </Typography>
          <TooltipInvestment variant="bodyXS">
            {toCurrency(investment - initialPatrimony)}
          </TooltipInvestment>
        </InfoLine>
        <InfoLine>
          <Typography variant="bodyXS">
            {formatMessage({
              id: 'wealth_simulator.chart.tootlip.patrimony',
            })}
          </Typography>
          <TooltipInitial variant="bodyXS">{toCurrency(initialPatrimony)}</TooltipInitial>
        </InfoLine>
      </TooltipInfos>
    </TooltipContainer>
  );
};

const TooltipContainer = styled('div', {
  minWidth: '200px',
  backdropFilter: 'blur(12px)',
  background: 'rgba(19, 19, 20, 0.2)',
  borderRadius: '16px',
  '&:active, &:focus': {
    border: '1px solid $borderSecondary',
  },
});

const Header = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '12px',
  borderBottom: '1px solid $webappTertiary',
});

const TooltipInfos = styled('div', {
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

const InfoLine = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});

const TooltipInterest = styled(Typography, {
  color: '#F49352 !important',
});

const TooltipInitial = styled(Typography, {
  color: '#D6475D !important',
});

const TooltipInvestment = styled(Typography, {
  color: '#6F50E5 !important',
});
